import React from "react";
import { Container, Row, Col, Table } from "react-bootstrap";
import "./All_bets_history.css";

function All_bets_history() {
  const data = [
    {
      date: "24.SEP.24",
      rows: [
        { time: "12:25 p", bet: "1", round: "1", payout: "0.000000", win: true },
        { time: "12:27 p", bet: "10", round: "2", payout: "0.000000", win: true },
        { time: "12:30 p", bet: "100", round: "3", payout: "0.000000", win: false },
        { time: "12:35 p", bet: "1K", round: "4", payout: "0.000000", win: false },
        { time: "12:37 p", bet: "100", round: "5", payout: "0.000000", win: true },
      ],
    },
    {
      date: "22.SEP.24",
      rows: [
        { time: "12:25 p", bet: "1", round: "1", payout: "0.000000", win: true },
        { time: "12:27 p", bet: "10", round: "2", payout: "0.000000", win: true },
        { time: "12:30 p", bet: "100", round: "3", payout: "0.000000", win: false },
        { time: "12:35 p", bet: "1K", round: "4", payout: "0.000000", win: false },
        { time: "12:37 p", bet: "100", round: "5", payout: "0.000000", win: true },
      ],
    },
  ];

  return (
    <section className="All_bets_history  history_inner_tab_content py-4">
      <Container>
        {data.map((section, index) => (
          <div key={index} className="All_bets_history_section mb-4">
            <Row className="align-items-center justify-content-between mb-2">
              <Col xs="auto">
                <h6 className="All_bets_history_date">{section.date}</h6>
              </Col>
              <Col xs="auto">
                <p className="All_bets_history_search">Search by Date ▼</p>
              </Col>
            </Row>

            <div className="All_bets_history_table_wrapper">
              <Table responsive className="All_bets_history_table mb-0">
                <thead>
                  <tr>
                    <th>Time</th>
                    <th>Bet</th>
                    <th>Round</th>
                    <th>Payout</th>
                  </tr>
                </thead>
                <tbody>
                  {section.rows.map((row, idx) => (
                    <tr key={idx}>
                      <td>{row.time}</td>
                      <td>{row.bet}</td>
                      <td>{row.round}</td>
                      <td
                        className={
                          row.win
                            ? "All_bets_history_payout_win"
                            : "All_bets_history_payout_lose"
                        }
                      >
                        {row.payout}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </div>
        ))}
      </Container>
    </section>
  );
}

export default All_bets_history;
